import validator from 'validator'

import {userAccountRegister, userAccountUpdate} from '../../api'

const userApiStore = {
  state: {
    cognitoId: '',
    givenName: '',
    surName: '',
    emailAddress: '',
    lastModified: 0,
    phoneNumberMobile: '',
    phoneNumberHome: '',
    unprocessedChange: '',
    userId: '',
    newUser: true,
    validationRequired: true
  },
  getters: {
    accountRetrieved: state => {
      return state.userId !== ''
    },
    userId: state => {
      return state.userId || ''
    },
    givenName: (state, getters) => {
      return state.givenName || ''
    },
    surName: (state, getters) => {
      return state.surName || ''
    },
    fullName: state => {
      return (state.givenName || '') + ' ' + (state.surName || '')
    },
    emailAddress: (state, getters) => {
      return state.emailAddress || ''
    },
    userLastModified: state => {
      let timestamp = new Date(state.lastModifiedDate)
      return timestamp.toString()
    },
    mobilePhoneNumber: state => {
      return state.phoneNumberMobile || ''
    },
    homePhoneNumber: state => {
      return state.phoneNumberHome || ''
    },
    userAccountUnprocessedChange: state => {
      return state.unprocessedChange
    },
    newUser: state => {
      return state.newUser
    },
    validationRequired: state => {
      return state.validationRequired
    },
    user: (state, getters) => {
      let account = Object.assign({}, state)

      account.fullName = getters.fullName
      account.lastModified = getters.lastModified

      return account
    },
    givenNameValid: (state, getters) => {
      return getters.givenName.length > 0
    },
    surNameValid: (state, getters) => {
      return getters.surName.length > 0
    },
    emailAddressValid: (state, getters) => {
      const emailAddress = getters.emailAddress
      return emailAddress.length > 0 && validator.isEmail(emailAddress)
    },
    mobilePhoneNumberValid: (state, getters) => {
      const mobilePhoneNumber = getters.mobilePhoneNumber
      return mobilePhoneNumber.length === 0 || validator.isMobilePhone(mobilePhoneNumber, getters.locale)
    },
    homePhoneNumberValid: (state, getters) => {
      const homePhoneNumber = getters.homePhoneNumber
      return homePhoneNumber.length === 0 || validator.isMobilePhone(homePhoneNumber, getters.locale)
    },
    phoneNumberValid: (state, getters) => {
      return getters.mobilePhoneNumberValid && getters.homePhoneNumberValid &&
              (getters.mobilePhoneNumber.length > 0 || getters.homePhoneNumber.length > 0)
    },
    userInputValid: (state, getters) => {
      return getters.givenNameValid &&
              getters.surNameValid &&
              getters.emailAddressValid &&
              getters.phoneNumberValid
    }
  },
  mutations: {
    updateUserId (state, userId) {
      state.userId = userId
    },
    updateCognitoId (state, cognitoId) {
      state.cognitoId = cognitoId
    },
    updateGivenName (state, givenName, override = false) {
      if (givenName !== undefined || override) {
        state.givenName = givenName
      }
    },
    updateSurName (state, surName, override = false) {
      if (surName !== undefined || override) {
        state.surName = surName
      }
    },
    updateEmailAddress (state, emailAddress, override = false) {
      if (emailAddress !== undefined || override) {
        state.emailAddress = emailAddress
      }
    },
    updateUserLastModified (state, lastModified) {
      // TODO do we need to check the type provided for a Date vs a unix timestamp?
      state.lastModified = lastModified
    },
    updatePhoneNumberHome (state, phoneNumberHome) {
      state.phoneNumberHome = phoneNumberHome
    },
    updatePhoneNumberMobile (state, phoneNumberMobile) {
      state.phoneNumberMobile = phoneNumberMobile
    },
    updateNewUser (state, newUser) {
      state.newUser = newUser
    },
    updateValidationRequired (state, validationRequired) {
      state.validationRequired = validationRequired
    }
  },
  actions: {
    /**
     * Update the local state with teh account info
     */
    updateUserState (context, accountInfo) {
      context.commit('updateUserId', accountInfo.userId)
      context.commit('updateCognitoId', accountInfo.cognitoId)
      context.commit('updateGivenName', accountInfo.givenName)
      context.commit('updateSurName', accountInfo.surName)
      context.commit('updateEmailAddress', accountInfo.emailAddress)
      context.commit('updateUserLastModified', accountInfo.lastModified)
      context.commit('updatePhoneNumberMobile', accountInfo.phoneNumberMobile)
      context.commit('updatePhoneNumberHome', accountInfo.phoneNumberHome)
      context.commit('updateNewUser', accountInfo.newUser)
      context.commit('updateValidationRequired', accountInfo.validationRequired)
    },
    /**
     * User Account Register API Method
     */
    userAccountRegister (context) {
      const apiClient = context.getters.apiClient
      const cognitoId = context.getters.credentials.identityId
      const emailAddress = context.getters.authEmailAddress

      return userAccountRegister(apiClient, cognitoId, emailAddress)
        .then((accountInfo) => {
          context.dispatch('updateUserState', accountInfo)
            .then(() => {
              context.dispatch('userAddressRetrieve')
              context.dispatch('serviceRetrieve')
            })
          console.log('Retrieved account data: %j', accountInfo)
          return accountInfo
        })
        .catch((error) => {
          // TODO track the error message somewhere?
          throw error
        })
    },
    /**
     * Send updated account details
     */
    userAccountUpdate (context) {
      const apiClient = context.getters.apiClient
      const accountInfo = context.getters.user

      return userAccountUpdate(apiClient, accountInfo)
        .then((accountInfo) => {
          context.dispatch('updateUserState', accountInfo)
          console.log('Retrieved account data: %j', accountInfo)
          return accountInfo
        })
        .catch((error) => {
          // TODO track the error message somewhere?
          throw error
        })
    }
  }
}

export default userApiStore



// WEBPACK FOOTER //
// ./src/store/app/user.js